import { Alignment } from '@faire/web-api--source/indigofair/data/Alignment';
import { ColorTokenKey } from '@faire/web-api--source/indigofair/data/ColorTokenKey';
import { IAction } from '@faire/web-api--source/indigofair/data/IAction';
import { IElementLoggingData } from '@faire/web-api--source/indigofair/data/IElementLoggingData';
import { IImageOrIcon } from '@faire/web-api--source/indigofair/data/IImageOrIcon';
import { TextJustification } from '@faire/web-api--source/indigofair/data/TextJustification';
import { TextStyleType } from '@faire/web-api--source/indigofair/data/TextStyleType';

export namespace ITextElement {
  export namespace ITextElementStyle {
    /**
     * Return an instance of ITextElementStyle with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<ITextElementStyle>
    ): ITextElementStyle =>
      ({
        ...(partial ?? {}),
      }) as ITextElementStyle;
  }

  export interface ITextElementStyle {
    color: keyof typeof ColorTokenKey | undefined;
    decorator: keyof typeof ITextElement.TextDecorator | undefined;
    type: keyof typeof TextStyleType | undefined;
    max_lines: number | undefined;
    text_justification: keyof typeof TextJustification | undefined;
    prefix_element_vertical_alignment: keyof typeof Alignment | undefined;
  }

  /**
   * TextElement.TextDecorator is to be deprecated, please use TextDecorator in the future
   */
  export enum TextDecorator {
    TEXT_DECORATOR_UNKNOWN = 'TEXT_DECORATOR_UNKNOWN',
    /**
     * SECTION_HEADER, PAGE_HEADER, DISPLAY_M, DISPLAY_L, DISPLAY_XL
     * don't have emphasis.
     */
    EMPHASIS = 'EMPHASIS',
    LINK = 'LINK',
    STRIKE_THROUGH = 'STRIKE_THROUGH',
  }

  /**
   * Return an instance of ITextElement with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<ITextElement>): ITextElement =>
    ({
      suffix_c_t_a_on_click: [],
      ...(partial ?? {}),
    }) as ITextElement;
}

/**
 * DEPRECATED use SDUIText
 * @deprecated
 */
export interface ITextElement {
  style: ITextElement.ITextElementStyle | undefined;
  text: string | undefined;
  suffix_c_t_a: string | undefined;
  suffix_c_t_a_on_click: Array<IAction>;
  /**
   * Optional for non-SDUI logging or action.
   */
  logging_data: IElementLoggingData | undefined;
  /**
   * The prefix element that displayed in front of the text content. It is rendered in-line with the text content.
   */
  prefix_element: IImageOrIcon | undefined;
}
